/**
 * Thin wrapper around the shared recordDemoEvent service. Reads the
 * active demo session from the auth store and silently no-ops if:
 *   - the user is not authenticated
 *   - the user is not in a demo session (isDemo=false or no demoSessionId)
 *   - the underlying network call fails
 *
 * Analytics must never break the demo flow. Every call site is
 * fire-and-forget; no caller awaits or handles errors.
 *
 * Usage:
 *   import { trackDemoEvent } from '@/lib/trackDemoEvent';
 *
 *   trackDemoEvent({ type: 'action', name: 'invite_sent', surface: 'cleo' });
 *   trackDemoEvent({ type: 'surface_visit', name: 'cleo_opened', surface: 'cleo' });
 */

import { useAuthStore, demoService } from '@vesper/shared';

export interface TrackEventInput {
  type: 'surface_visit' | 'action';
  name: string;
  surface?: string;
  metadata?: Record<string, unknown>;
}

export function trackDemoEvent(input: TrackEventInput): void {
  const user = useAuthStore.getState().user;
  if (!user?.isDemo || !user.demoSessionId) return;

  void demoService.recordDemoEvent({
    sessionId: user.demoSessionId,
    eventType: input.type,
    eventName: input.name,
    surface: input.surface,
    metadata: input.metadata,
  });
}
